import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import Table from './Table'
import { fetchTracks } from '../../api'
import * as actions from '../../actions'
import { getVisibleTracks } from '../../reducers/tracks'

import { nextBookOfBible, unSlugify, whichTestament, capitalize } from '../../utils'

import Layout from './Layout'
import Topbar from '../Topbar'
import Clock from '../visuals/Clock'
import PlayButton from './PlayButton'
import DownloadTrackButton from './DownloadTrackButton'
import moment from 'moment'

const BookVisual = styled.div`
  position: relative;
  padding: 24px 32px;
  /* Make space for the pos:fixed Topbar */
  margin-top: 56px;
`
const ToParentLink = styled(Link)`
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 20px;
  color: #c4c4c4;
  padding-bottom: 3px;
  border-bottom: 1px solid #c4c4c4;
`

const ToNextBookLink = styled(Link)`
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 20px;
  color: #c4c4c4;
  padding-bottom: 3px;
  border-bottom: 1px solid #c4c4c4;
  float: right;
`

const BookTitle = styled.h1`
  margin-top: 24px;
  margin-bottom: 0px;
  font-family: 'Source Sans Pro';
  font-weight: bold;
  font-size: 56px;
  line-height: 70px;
  color: #fff;
  text-transform: capitalize;
`

const DownloadAllButton = styled.button`
  appearance: none;
  padding: 6px 20px;
  background: none;

  border: 1px solid #f1f1f1;
  border-radius: 16px;

  font-family: 'Source Sans Pro';
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: #f1f1f1;
`

const TrackNumber = styled.span``

const mapStateToProps = (state, ownProps) => ({
  book: ownProps.match.params.book,
  tracks: getVisibleTracks(state.tracks)
})

const mapDispatchToProps = (dispatch) => ({
  receiveTracks: (book, tracks) => dispatch(actions.receiveTracks(book, tracks))
})

class Book extends React.Component {
  componentDidMount () {
    this.fetchData()
  }

  componentDidUpdate (prevProps) {
    if (this.props.book !== prevProps.book) {
      this.fetchData()
    }
  }

  fetchData () {

    // It's actually important to desctructure book, because the user may have requested a new chapter to view, thus changing this.props.book. We're using book in the promise response
    const { book, receiveTracks } = this.props

    // First clear the tracks
    receiveTracks(book, [])

    // Then fetch new ones
    fetchTracks(book).then( tracks => {
      console.log(tracks)
      receiveTracks(book, tracks)
    })
  }

  render () {
    const testament = whichTestament(this.props.book)

    return (
      <Layout>
        <BookVisual>
          <ToParentLink to={`${process.env.REACT_APP_APP_HOIST}/${testament}-testament`}>{`Back to ${capitalize(testament)} Testament Index`}</ToParentLink>
          <ToNextBookLink to={`${process.env.REACT_APP_APP_HOIST}/${nextBookOfBible(this.props.book).slug}`}>To {nextBookOfBible(this.props.book).title}</ToNextBookLink>
          <BookTitle>{unSlugify(this.props.book)}</BookTitle>
          <DownloadAllButton>Download</DownloadAllButton>

          <Table
              rows={this.props.tracks.map( (track, i) => [
                [
                  <span className='trackNumber'>{i+1}</span>,
                  <PlayButton additionalClassName='playButton' track={track} />
                ],
                <DownloadTrackButton track={track} />,
                `${track.book} ${track.chapter}`,
                '',
                moment.duration(track.duration, 'seconds').format('mm:ss', {trim: false})
              ])}
              rowKey='id'
              hoverStyles={`
                .trackNumber {
                  display: none;
                }
                .playButton {
                  display: inline;
                }
              `}
              headings={['#', '', 'Title', '', <Clock />]}
              layouts={[
                {width: '24', padding: '24', side: 'left'},
                {width: '17', padding: '16', side: 'left'},
                {padding: '24', side: 'left'},
                {width: '18', padding: '24', side: 'right'},
                {width: '36', padding: '24', side: 'right'}
              ]}

            />
        </BookVisual>
        <Topbar />
      </Layout>
    )
  }
}

Book = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Book))

export default Book



// WEBPACK FOOTER //
// ./src/components/Main/Book.js